<template>
  <div>
    <base-card>
      <div class="validate-container d-flex align-center mb_50">
        <div class="col-xs-8 pt_25 mt_30 mb_25 validate-icon-container">
          <i class="validate-icon far fa-spinner fa-pulse" />
        </div>
        <div class="validate-text mt_10 col-xs-8">
          <p class="text-center">Verificação do cartão em andamento.</p>
          <p class="text-center">Isso pode levar alguns minutos.</p>
        </div>
      </div>
    </base-card>
  </div>
</template>
<script>
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";

export default {
  components: { BaseCard },
};
</script>
<style scoped>
.validate-container {
  flex-direction: column;
}

.validate-container .validate-icon-container {
  text-align: center;
}

.validate-container .validate-icon-container .validate-icon {
  font-size: 80px;
  color: #0099ffcc;
}

.validate-text p {
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}
</style>